import { useState } from "react";
import {
  addLinkedRecordingSession,
  type LinkedRecordingSessionResponse,
} from "@/services/linkedRecordingSessions";

export const useCreateLinkedRecordingSession = (): {
  createLinkedRecordingSession: (
    userId: number,
    deviceId: string
  ) => Promise<void>;
  result: LinkedRecordingSessionResponse | null;
  loading: boolean;
  error: string | null;
  reset: () => void;
} => {
  const [result, setResult] = useState<LinkedRecordingSessionResponse | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const createLinkedRecordingSession = async (
    userId: number,
    deviceId: string
  ): Promise<void> => {
    setResult(null);
    setLoading(true);
    setError(null);
    try {
      const data = await addLinkedRecordingSession({ userId, deviceId });
      setResult(data);
    } catch {
      setResult(null);
      setError("Error to create an linked recording session");
    } finally {
      setLoading(false);
    }
  };

  const reset = (): void => {
    setResult(null);
    setLoading(false);
    setError(null);
  };

  return { createLinkedRecordingSession, result, loading, error, reset };
};
